/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SignalWithAlarmState
 */
export interface SignalWithAlarmState {
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  name: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalWithAlarmState
   */
  lastSuccessTimestamp: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof SignalWithAlarmState
   */
  errorThresholdHours?: number | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalWithAlarmState
   */
  alarmSilencedUntilTimestamp?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  requiresActiveShipmentsCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  requiresActiveShipmentsServiceIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  serviceType?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SignalWithAlarmState
   */
  isInAlarmState: boolean;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  matchedRulePrefix?: string | null;
  /**
   *
   * @type {number}
   * @memberof SignalWithAlarmState
   */
  businessDayThreshold?: number | null;
  /**
   *
   * @type {number}
   * @memberof SignalWithAlarmState
   */
  businessDaysCount?: number | null;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  lastLiveShipmentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalWithAlarmState
   */
  lastDeliveredShipmentId?: string | null;
}

/**
 * Check if a given object implements the SignalWithAlarmState interface.
 */
export function instanceOfSignalWithAlarmState(
  value: object,
): value is SignalWithAlarmState {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    !("lastSuccessTimestamp" in value) ||
    value["lastSuccessTimestamp"] === undefined
  )
    return false;
  if (!("isInAlarmState" in value) || value["isInAlarmState"] === undefined)
    return false;
  return true;
}

export function SignalWithAlarmStateFromJSON(json: any): SignalWithAlarmState {
  return SignalWithAlarmStateFromJSONTyped(json, false);
}

export function SignalWithAlarmStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignalWithAlarmState {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    lastSuccessTimestamp: json["lastSuccessTimestamp"],
    errorThresholdHours:
      json["errorThresholdHours"] == null
        ? undefined
        : json["errorThresholdHours"],
    alarmSilencedUntilTimestamp:
      json["alarmSilencedUntilTimestamp"] == null
        ? undefined
        : json["alarmSilencedUntilTimestamp"],
    requiresActiveShipmentsCarrierIdentifier:
      json["requiresActiveShipmentsCarrierIdentifier"] == null
        ? undefined
        : json["requiresActiveShipmentsCarrierIdentifier"],
    requiresActiveShipmentsServiceIdentifier:
      json["requiresActiveShipmentsServiceIdentifier"] == null
        ? undefined
        : json["requiresActiveShipmentsServiceIdentifier"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceType: json["serviceType"] == null ? undefined : json["serviceType"],
    isInAlarmState: json["isInAlarmState"],
    matchedRulePrefix:
      json["matchedRulePrefix"] == null ? undefined : json["matchedRulePrefix"],
    businessDayThreshold:
      json["businessDayThreshold"] == null
        ? undefined
        : json["businessDayThreshold"],
    businessDaysCount:
      json["businessDaysCount"] == null ? undefined : json["businessDaysCount"],
    lastLiveShipmentId:
      json["lastLiveShipmentId"] == null
        ? undefined
        : json["lastLiveShipmentId"],
    lastDeliveredShipmentId:
      json["lastDeliveredShipmentId"] == null
        ? undefined
        : json["lastDeliveredShipmentId"],
  };
}

export function SignalWithAlarmStateToJSON(json: any): SignalWithAlarmState {
  return SignalWithAlarmStateToJSONTyped(json, false);
}

export function SignalWithAlarmStateToJSONTyped(
  value?: SignalWithAlarmState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    lastSuccessTimestamp: value["lastSuccessTimestamp"],
    errorThresholdHours: value["errorThresholdHours"],
    alarmSilencedUntilTimestamp: value["alarmSilencedUntilTimestamp"],
    requiresActiveShipmentsCarrierIdentifier:
      value["requiresActiveShipmentsCarrierIdentifier"],
    requiresActiveShipmentsServiceIdentifier:
      value["requiresActiveShipmentsServiceIdentifier"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceType: value["serviceType"],
    isInAlarmState: value["isInAlarmState"],
    matchedRulePrefix: value["matchedRulePrefix"],
    businessDayThreshold: value["businessDayThreshold"],
    businessDaysCount: value["businessDaysCount"],
    lastLiveShipmentId: value["lastLiveShipmentId"],
    lastDeliveredShipmentId: value["lastDeliveredShipmentId"],
  };
}
